<template lang="pug">
  div.techsigns-list
    figure.techsigns-list__name(v-for="tech in techsigns" v-in-viewport.once="true")
      img(:src="tech.src" :alt="tech.name")
      figcaption {{ tech.name }}
</template>


<script>
  export default {
    name: 'Techdesign',

    data: () => ({
      techsigns: [
        { name: 'GreenSock', src: require('../assets/images/logos/gsap.svg') },
        { name: 'Sketch', src: require('../assets/images/logos/sketch.svg') },
        { name: 'Photoshop', src: require('../assets/images/logos/photoshop.svg') },
        // { name: 'AxureRP', src: require('../assets/images/logos/axurerp.svg') },
        { name: 'Invision', src: require('../assets/images/logos/invision.svg') }
      ]
    })
  }
</script>


<style lang="sass">
  .techsigns-list
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    margin: 4em 0
    margin-left: -5vw // wtf?
    +unselectable
    &__name
      width: 45%
      margin: 0
      padding-bottom: 40px
      text-align: center
      opacity: 0
      +breakpoint(sm)
        padding-bottom: 60px
        width: 19.5%
      // Animation
      @for $i from 1 through 4
        &:nth-of-type(#{$i})
          &.in-viewport
            animation: (0.5s + ($i - 1) * 0.1s) fadeInUp2 (1000ms + ($i - 1) * 0.1s) both

      > img
        display: inline-block
        width: 50%

      > figcaption
        font-size: .850rem
        margin: 0 auto
        max-width: 170px
        +breakpoint(md)
          font-size: 1rem
        +breakpoint(lg)
          font-size: 1.250rem
</style>



// WEBPACK FOOTER //
// src/components/Techdesign.vue